export default 48 * 60 * 60 * 1000
